import Vue, { CreateElement } from '@src/vue'

import { Component } from 'vue-property-decorator'

import './dialog.sass'

@Component
export class Dialog extends Vue {

  render (h: CreateElement) {
    return <div class='dialog'>

      <div class='slot default'>
        {this.$slots.default}
      </div>

      <div class='slot bottom'>
        {this.$slots.bottom}
      </div>

    </div>
  }

}
